import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectFinancialSejamProfile: "selectFinancialSejamProfile [Action]",
  selectFinancialSejamProfileLoading:
    "selectFinancialSejamProfileLoading [Action]",
  selectFinancialSejamProfileAsync: "selectFinancialSejamProfileAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectFinancialSejamProfileReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectFinancialSejamProfile:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectFinancialSejamProfileLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectFinancialSejamProfileLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_financial_sejam_profile",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectFinancialSejamProfile,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectFinancialSejamProfileLoading,
      payload: false,
    });
  }
}

export function* selectFinancialSejamProfile() {
  yield takeLatest(actionTypes.selectFinancialSejamProfileAsync, handleWorker);
}
